import React from 'react';
import api from '../../../services/api';
import { jsPDF } from 'jspdf';

const ImageBlock = ({ block }) => {
  if (!block.imageUrl) return null;

  const handleImageError = (e) => {
    alert('Image failed to load. Please try again.');
  };

  const downloadAsPDF = (imageUrl, filename) => {
    const pdf = new jsPDF();
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.onload = function() {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      
      const imgData = canvas.toDataURL('image/png');
      
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      pdf.save(filename.replace(/\.[^/.]+$/, "") + ".pdf");
    };
    img.src = imageUrl;
  };

  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      const urlParts = block.imageUrl.split('/');
      let filename = urlParts[urlParts.length - 1] || 'image.png';
      filename = filename.split('?')[0];
      const pdfFilename = filename.replace(/\.[^/.]+$/, "") + ".pdf";

      if (block.imageUrl.startsWith('data:')) {
        downloadAsPDF(block.imageUrl, pdfFilename);
        return;
      }

      if (block.imageUrl.startsWith('/') && !block.imageUrl.startsWith('//')) {
        downloadAsPDF(block.imageUrl, pdfFilename);
        return;
      }

      try {
        const response = await api.get('/documents/s3-download', {
          params: {
            url: block.imageUrl,
            filename: filename
          },
          responseType: 'blob',
        });
        
        const blobUrl = window.URL.createObjectURL(response.data);
        downloadAsPDF(blobUrl, pdfFilename);
        
        setTimeout(() => {
          window.URL.revokeObjectURL(blobUrl);
        }, 1000);
      } catch (apiError) {
        console.error('Backend download failed, trying direct method:', apiError);
        downloadAsPDF(block.imageUrl, pdfFilename);
      }
    } catch (error) {
      console.error('Download error:', error);
      window.open(block.imageUrl, '_blank');
    }
  };

  return (
    <div className="mb-6 text-center">
      {block.downloadable && (
        <div className="mb-3 flex justify-center">
          <button
            onClick={handleDownload}
            className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg shadow-lg transition-all flex items-center gap-2 font-semibold text-sm"
            title="Download"
            aria-label="Download image"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            <span>Download</span>
          </button>
        </div>
      )}
      <div className="inline-block">
        <img 
          src={block.imageUrl} 
          alt={block.altText || 'Lesson image'}
          className="max-w-full h-auto rounded-lg shadow-md mx-auto"
          onError={handleImageError}
        />
      </div>
      {block.caption && (
        <p className="text-sm text-gray-600 mt-2 italic">
          {block.caption}
        </p>
      )}
    </div>
  );
};

export default ImageBlock;
